import { render, staticRenderFns } from "./StudentWorks.vue?vue&type=template&id=6d155dbe&scoped=true&"
import script from "./StudentWorks.vue?vue&type=script&lang=js&"
export * from "./StudentWorks.vue?vue&type=script&lang=js&"
import style0 from "./StudentWorks.vue?vue&type=style&index=0&id=6d155dbe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d155dbe",
  null
  
)

export default component.exports